import React from "react";
import {
  Stack,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";

interface EmployeeCostSourceSelectorProps {
  value?: "TIMESITE_PRO" | "MYOB_PAYROLL";
  onChange: (value: "TIMESITE_PRO" | "MYOB_PAYROLL") => void;
  disabled?: boolean;
}

const EmployeeCostSourceSelector: React.FC<EmployeeCostSourceSelectorProps> = ({
  value = "TIMESITE_PRO",
  onChange,
  disabled = false,
}) => {
  return (
    <Stack direction="column" sx={{ gap: 1 }}>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 400, fontSize: "14px", textAlign: "left" }}
      >
        <b>Employee Cost Source </b>
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", mb: 1, textAlign: "left" }}
      >
        Choose where employee cost data should be pulled from for payroll
        calculations.
      </Typography>
      <RadioGroup
        name="employee_cost_source"
        value={value}
        onChange={(e) => {
          onChange(e.target.value as "TIMESITE_PRO" | "MYOB_PAYROLL");
        }}
        sx={{ flexDirection: "row", gap: 3 }}
      >
        <FormControlLabel
          value="TIMESITE_PRO"
          control={<Radio disabled={disabled} />}
          label="Timesite Pro"
          disabled={disabled}
        />
        <FormControlLabel
          value="MYOB_PAYROLL"
          control={<Radio disabled={disabled} />}
          label="MYOB Payroll"
          disabled={disabled}
        />
      </RadioGroup>
    </Stack>
  );
};

export default EmployeeCostSourceSelector;
